import { ClientesPymesService } from './../../services/clientes-pymes.service';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css']
})
export class DocumentosComponent implements OnInit {

  aniosLaboral;
  aniosFiscal;
  aniosContable;

  constructor(private auth:AuthService, private clientesPymesService:ClientesPymesService) {

    this.cargarAnios();
  }

  ngOnInit() {
  }

  cargarAnios(){
    this.clientesPymesService.AniosLaboral(this.auth.usuarioActivo.CLcodigo)
    .subscribe(resp=>{
      this.aniosLaboral=resp;
      
    });
    this.clientesPymesService.AniosFiscal(this.auth.usuarioActivo.CLcodigo)
    .subscribe(resp=>{
      this.aniosFiscal=resp;
      
    });
    this.clientesPymesService.AniosContable(this.auth.usuarioActivo.CLcodigo)
    .subscribe(resp=>{
      this.aniosContable=resp;
      
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/documentos/documentos.component.ts